import { Component, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'ea-ui-overlay',
	templateUrl: './overlay.component.html',
	styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent {
	// eslint-disable-next-line @angular-eslint/no-output-native
	@Output() readonly close = new EventEmitter<any>();

	handleClose(): void {
		this.close.emit();
	}
}
